<template>
	<div>
		<div class="container">
			<div class="row">
				<div class="col-12 biz-title-container">
					<div class="container">
						<div class="biz-panel-title">
							<h3>Komentari</h3>
							<div class="text-right">
								<div class="ratings-left-rating">
									<h1>{{Number(user.salon.rating).toFixed(1).toString().replace('.',',')}}</h1>
								</div>
								<div class="ratings-left-num pl-2">
									<small>({{user.salon.rate_real_count}} ocjena)</small>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12">
						<notify></notify>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 salon-container mb-3">
					<div class="container mb-3">
						<div class="row no-gutters">
							<div v-for="(comment,index) in comments" :key="index" class="col-12">
								<div class="row no-gutters">
									<div class="col-12 komentar-header">
										<div class="komentar-header-left">
											<small class="komentar-date">{{format_croatia_date(new Date(comment.created_at).toDateString())}}</small>
											<h4 class="komentar-username">{{comment.user.name}}</h4>
											<div class="mt-1">
												<span :class="comment.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
												<span :class="comment.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
												<span :class="comment.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
												<span :class="comment.rating >= 4  ? 'fa fa-star checked':'fa fa-star'"></span>
												<span :class="comment.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
											</div>
										</div>
										<div v-if="comment.response == 0" class="komentar-header-right">
											<div class="komentar-btns">
												<a @click="selectedComment=comment.id" href="#" data-toggle="modal" data-target="#replyKomModal" class="btn fs-btn dark small"><span class="fas fa-reply"></span></a>
											</div>
										</div>
									</div>
									<div class="col-12 komentar-body">
										<p class="komentar-tekst">{{comment.text}}</p>
									</div>
								</div>
								<div v-for="(response,index) in comment.response" :key="index" class="col-12 komentar-div response">
									<div class="row no-gutters">
										<div class="col-12 komentar-header">
											<div class="komentar-header-left">
												<h4 v-if="response.user.id == user.salon.user_id" class="komentar-username">{{user.salon.name}}</h4>
												<h4 v-else class="komentar-username">{{response.user.name}}</h4>
											</div>
											<div class="komentar-header-right">
												<small class="komentar-date">{{format_croatia_date(new Date(comment.created_at).toDateString())}}</small>
											</div>
										</div>
										<div class="col-12 komentar-body">
											<p class="komentar-tekst">{{response.text}}</p>
										</div>
									</div>
								</div>
							</div>
							<div style="margin:auto" v-if="loadingComment">
								<loader color='red'></loader>
							</div>
							<!-- pagination stranice -->
							<div v-if="last_page > 1" class="col-12">
								<nav aria-label="Page navigation">
									<ul class="pagination justify-content-center">
										<li class="page-item align-self-center">
											<a @click="loadComment(comment_current_page <=0 ? 0:comment_current_page - 1)" class="page-link" aria-label="Previous">
												<span aria-hidden="true">&laquo;</span>
												<span class="sr-only">Previous</span>
											</a>
										</li>
										<li v-for="(page,index) in pagination" :key="index" :class="page == comment_current_page ? 'page-item active':'page-item '"><a class="page-link" @click="loadComment(page)">{{page}}</a></li>
										<li class="page-item">
											<a @click="loadComment(comment_current_page >= last_page ? last_page:comment_current_page + 1)" class="page-link" aria-label="Next">
												<span aria-hidden="true">&raquo;</span>
												<span class="sr-only">Next</span>
											</a>
										</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal animated fadeIn" id="replyKomModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<h4 class="modal-title w-100 font-weight-bold">Odgovori na komentar</h4>
						<button id="close" type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body mx-3">
						<form id="" action="" method="post">
							<div class="row">
								<div class="col-12 mb-3">
									<textarea v-model="response" class="form-control" id="servArea" rows="3" placeholder="Napišite vaš odgovor na komentar" aria-label="odgovor na komentar" aria-describedby="odgovor na komentar" required></textarea>
								</div>
							</div>
							<notify></notify>
							<button @click="respond()" id="button" type="button" class="fs-btn dark text-uppercase btn-lg btn-block">
								<loader v-if="loading" color='red'></loader>
								<span v-else>Pošalji</span>
							</button>
						</form>
					</div>
					<div id="book-modal-footer" class="modal-footer">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		module_mixin
	} from '../../../mixins/index';
	import {
		mapState
	} from 'vuex';
	export default {
		mixins: [module_mixin],
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				token: (state) => state.token,
				endpoint: (state) => state.endpoint,
				comments: (state) => state.comments,
			})
		},
		data() {
			return {
				loadingComment: false,
				comment_current_page: 1,
				last_page: 0,
				pagination: [],
				response: '',
				selectedComment: 0,
				loading: false
			}
		},
		methods: {
			respond() {
				this.loading = true;
				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'respond-to-comment/' + this.selectedComment + "?token=" + this.token,
						details: {
							text: this.response
						}
					})
					.then((data) => {
						// console.log(data);
						if (data.data.status) {
							this.comments = this.comments.map((d) => {
								if (d.id == data.data.data.parent_id) {
									d.response = d.response != undefined ? [...d.response, data.data.data] : [data.data.data];
								}
								return d;
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
							document.getElementById('close').click();
							this.response = '';
						} else {
							this.$store.commit('setNotification', {
								type: 2,
								msg: data.data.message
							});
						}
						this.loading = false;
					})
					.catch((error) => {
						console.log(error.request);
						this.loading = false;
					});
			},
			loadComment(page) {
				this.loadingComment = true;
				this.$store.dispatch('get', this.endpoint + 'get-salon-comments/' + this.user.salon.id + '?page=' + page)
					.then((data) => {
						// console.log(data.data);
						this.$store.state.comments = data.data.data;
						this.comment_current_page = data.data.current_page;
						this.last_page = data.data.last_page;
						this.pagination = [];
						for (var c = 1; c <= data.data.last_page; c++) {
							this.pagination.push(c);
						}
						this.loadingComment = false;
					})
					.catch((error) => {
						console.log(error.request);
						this.loadingComment = false
					});

			},
			formatDate(date) {
				return date.split('-').map((d) => {
					if (d.length < 4) {
						if (d.length < 2) {
							d = '0' + d.toString();
						}
					}
					return d;
				}).join('-');
			}
		},
		created() {
			this.loadComment(1);
		}
	}

</script>
<style scoped>
	.response {
		background: #d3d3d330;
		width: 80%;
		margin-left: auto;
		margin-top: 20px;
	}

</style>
